export const percentageToDecimal = (percentageValue: number) => percentageValue / 100;
